import { createContext, useContext } from 'react';

export const LanguageContext = createContext({
    currentLanguage: 'en',
    defaultLanguage: 'en',
    multiLanguageEnabled: false,
    isLanguageSwitchingEnabled: false,
    isGlobalAppRoute: false,
    isStoreRoute: false,
    isStoreLocaleReady: true,
    isStoreLanguageReady: true,
    routeStoreUsername: '',
    setLanguage: () => {},
});

export const useLanguageContext = () => useContext(LanguageContext);
